"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.5",
    y: "16.01",
    width: "4.47",
    height: "2.98"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.03",
    y: "16.01",
    width: "4.47",
    height: "2.98"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.5",
    y: "12.04",
    width: "4.47",
    height: "2.98"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.03",
    y: "12.04",
    width: "4.47",
    height: "2.98"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,23.47a.5.5,0,0,0,.5.5H23.43a.5.5,0,0,0,.5-.5h0V8H0ZM2.49,16a.5.5,0,0,1,0-1H5.91V12H2.49a.5.5,0,0,1,0-1H5.91V9.55a.5.5,0,0,1,1,0h0V11h4.47V9.55a.5.5,0,0,1,1,0V11H17V9.55a.5.5,0,0,1,1,0h0V11h3.43a.5.5,0,1,1,0,1H18v3h3.43a.5.5,0,1,1,0,1H18v3h3.43a.5.5,0,0,1,0,1H18v1.49a.5.5,0,0,1-1,0V20H12.5v1.49a.5.5,0,0,1-1,0V20H7v1.49a.5.5,0,0,1-1,0V20H2.61a.5.5,0,0,1,0-1H6V16Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.43,2.09H20V.6A.5.5,0,0,0,19.59,0H16.47a.5.5,0,0,0-.5.5V2.09H8V.6A.5.5,0,0,0,7.6,0H4.54a.5.5,0,0,0-.5.5V2.09H.62a.5.5,0,0,0-.62.5V7.06H24V2.59a.5.5,0,0,0-.49-.5ZM7,4.08H5v-3H7Zm12,0H17v-3h2Z"
  }));
};

exports["default"] = _default;